export const INVALID_QR_FILENAME_MESSAGE =
  "Invalid file name. Expected a UID prefix such as 25L001student_qr_with_logo.png.";
export const INVALID_ADMISSIONS_QR_FILENAME_MESSAGE =
  "Invalid file name. Expected first 6 characters as UID, for example 26X00A+student_qr_logo.png.";

const UID_PREFIX_PATTERN = /^(\d{2}[a-z0-9]\d{3})/i;
const ADMISSIONS_UID_PREFIX_PATTERN = /^[a-z0-9]{6}$/i;

export function normalizeStudentUid(value = "") {
  return String(value).trim().toUpperCase();
}

export function parseStudentUidFromFilename(fileName = "") {
  const basename = String(fileName)
    .split(/[\\/]/)
    .pop()
    ?.replace(/\.[^.]+$/, "")
    .trim();

  if (!basename) {
    return null;
  }

  const match = basename.match(UID_PREFIX_PATTERN);
  return match ? normalizeStudentUid(match[1]) : null;
}

export function parseStudentUidFromAdmissionsFilename(fileName = "") {
  const basename = String(fileName)
    .split(/[\\/]/)
    .pop()
    ?.replace(/\.[^.]+$/, "")
    .trim();

  if (!basename || basename.length < 6) {
    return null;
  }

  const uidPrefix = basename.slice(0, 6);
  return ADMISSIONS_UID_PREFIX_PATTERN.test(uidPrefix)
    ? normalizeStudentUid(uidPrefix)
    : null;
}

export function shouldActivateQrForStudentName(name = "") {
  const normalizedName = String(name).trim().toLowerCase();

  if (!normalizedName) {
    return false;
  }

  return !(
    normalizedName.startsWith("test") ||
    normalizedName.startsWith("student")
  );
}

export function isQrImageFile(file) {
  if (!file) {
    return false;
  }

  if (typeof file.type === "string" && file.type.startsWith("image/")) {
    return true;
  }

  return /\.(png|jpe?g|webp|gif|bmp|svg)$/i.test(file.name || "");
}
